import BrowerLogger from 'alife-logger';
const logger = (() => {
  console.log('logger当前环境====>', process.env.NODE_ENV);
  if (process.env.NODE_ENV === 'production') {
    try {
      return BrowerLogger.singleton({
        pid: 'bio0aqx9dv@5a9dea2cbf2cced', // 这是项目ID，新建一个应用站点后自动生成，在单个应用站点内部的`设置->应用设置`查看
        appType: 'web',
        imgUrl: 'https://arms-retcode.aliyuncs.com/r.png?', // 日志上传地址，源码中默认值就是这个地址
        sendResource: true,
        enableLinkTrace: true,
        behavior: true
      });
    }
    catch (e) {
      console.error('init logger fail', e);
    }
  }
  else {
    return {
      error() {}
    };
  }
})();

export default logger;
